import React, { useEffect, useState } from "react";
import { AssignHeading, AssignInspectorData } from "../../utils/helperData";
import Pagination from "../../customComponent/Pagination";
import { useNavigate, useParams } from "react-router";
import { VIEW_MANAGE_PROJECT_DETAILS } from "../../utils/RouteConstant";
import Eye from "../../../asesst/Eye.svg";
import { useDispatch, useSelector } from "react-redux";
import { IoIosSearch } from "react-icons/io";
import { fetchInspectorsProjectList } from "../../../redux/action/InspectorManagement/AddInspectorAction";

const AssignProjects = () => {
  const ITEMS_PER_PAGE = 10;
  const navigate = useNavigate();
  const { inspectorId } = useParams();
  console.log("inspectorID", inspectorId);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const { inspectorData } = useSelector((state) => state.inspector);
  console.log("innspectror data", inspectorData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchInspectorsProjectList(
        currentPage,
        ITEMS_PER_PAGE,
        searchTerm,
        "Assigned Projects",
        inspectorId
      )
    );
  }, [dispatch, currentPage, ITEMS_PER_PAGE, searchTerm]);
  const totalPages = Math.ceil(AssignInspectorData.length / ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleViewDetails = (projectId) => {
    navigate(`${VIEW_MANAGE_PROJECT_DETAILS}/${projectId}`);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div>
      <h1 className="text-3xl sm:text-3xl font-bold mb-6">Assigned Project</h1>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-6 space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-full sm:w-64 flex-grow sm:flex-grow-0">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearch}
            className="w-full lg:w-[400px] pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-[#F1F4F9]">
              <tr>
                {AssignHeading.map((head) => (
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {head.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {inspectorData?.data?.length > 0 ? (
                <>
                  {inspectorData?.data?.map((inspector, index) => (
                    <tr key={inspector._id}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {inspector?.project_id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {inspector?.project_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {inspector?.project_status === "COMPLETED"
                          ? "Completed"
                          : inspector?.project_status === "ONGOING"
                          ? "Ongoing"
                          : "Assigned"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {inspector?.assignedDate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <span
                          onClick={() => handleViewDetails(inspector?._id)}
                          className="text-[#1C3664] text-lg font-poppins cursor-pointer flex items-center"
                        >
                          <img src={Eye} alt="view details" className="mr-2" />
                          View Details
                        </span>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="6" className="px-6 py-4 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <img
                        src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                        alt="No Data"
                        className="mb-4 w-[200px] h-[200px]"
                      />
                      <p className="text-lg text-gray-500">
                        No assigned projects for this inspector.
                      </p>
                      <p className="text-sm text-gray-400">
                        Please check back later or assign new projects.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default AssignProjects;
